import { List, Record } from 'immutable'
import { AssociatedProperty, IAssociatedProperty } from './AssociatedProperty'

export interface IPropertyResult {
  resultCount: number
  results: List<IAssociatedProperty>
  timestamp: number
}

const PropertyResultRecord = Record({
  resultCount: 0,
  results: List<AssociatedProperty>(),
  timestamp: Math.round(new Date().getTime() / 1000),
})

export class PropertyResult extends PropertyResultRecord {
  public static fromJS(initialState?: Partial<IPropertyResult>) {
    if (!initialState) {
      return new PropertyResult()
    }

    const { resultCount, results, timestamp, ...rest } = initialState
    return new PropertyResult({
      ...rest,
    })
  }

  public readonly resultCount: number
  public readonly results: List<AssociatedProperty>
  public readonly timestamp: number

  constructor(initialState?: Partial<PropertyResult>) {
    initialState ? super(initialState) : super()
  }
}
